<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div
    class="h-screen flex w-full vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="vx-row w-full no-gutter justify-center items-center d-theme-dark-bg">
      <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg login-left">
        <div class="p-8 login-tabs-container items-left">
          <img
            class="mb-large"
            src="@/assets/images/logo/getboarded-logo.svg"
          />
          <div class="vx-card__title mb-5">
            <h3 class="mb-4">Login and Sign up</h3>
            <p v-if="!addToBoard">
              Our login is password-free, to sign up or log in you only have to
              provide your email address.
            </p>
            <p v-else>
              Our login is password-free, to sign up or log in you only have to
              provide your basic details.
            </p>
          </div>

          <div v-if="!otpSent" class="mb-large">
            <div class="mb-4">
              <vs-input
                v-validate="'required|email|min:3'"
                data-vv-validate-on="input"
                name="email"
                icon-no-border
                icon="icon icon-mail"
                icon-pack="feather"
                placeholder="Email"
                v-model="email"
                class="w-full"
                @input="checkIfUserExists"
                @blur="checkIfUserExists"
              />
              <span v-if="errors.first('email') && email" class="text-danger text-sm">{{
                errors.first("email")
              }}</span
              >
            </div>
            <div v-if="addToBoard && userCheckComplete && !userExists" class="vx-row">
              <div class="vx-col w-1/2">
                <vs-input
                  v-validate="'required'"
                  data-vv-validate-on="blur"
                  name="First Name"
                  placeholder="First Name"
                  v-model="firstName"
                  class="w-full"
                />
                <span v-if="errors.first('First Name')" class="text-danger text-sm">{{
                  errors.first("First Name")
                }}</span
                >
              </div>
              <div class="vx-col w-1/2">
                <vs-input
                  v-validate="'required'"
                  data-vv-validate-on="blur"
                  name="Last Name"
                  placeholder="Last Name"
                  v-model="lastName"
                  class="w-full"
                />
                <span v-if="errors.first('Last Name')" class="text-danger text-sm">{{
                  errors.first("Last Name")
                }}</span
                >
              </div>
            </div>
            <br />
            <vs-checkbox class="my-4" v-model="productUpdatesCheckbox"
              >I want to receive updates on products & campaigns</vs-checkbox
            >
            <div class="items-center">
              <vs-button class="w-full mt-5" size="large" @click="sendOTP()"
                >Send OTP</vs-button
              >
              <!-- <vs-divider class="my-base" />
              <vs-button
                color="white"
                class="w-full microsoft-login--btn"
                size="large"
                @click="microsoftSignIn()"
                ><img
                  class="mr-3"
                  width="32px"
                  height="32px"
                  src="@/assets/images/icons/azure-ad/microsoft-window-logo.png"
                />Sign in with Microsoft</vs-button
              > -->
            </div>
          </div>

          <div v-else class="mt-base mb-large">
            <!-- <vue-otp-2
              class="mb-base"
              length="6"
              join-character="-"
              @onComplete="verifyOTP"
            /> -->
            <div class="mb-base">
                <v-otp-input
                    ref="otpInput"
                    input-classes="otp-input"
                    separator="-"
                    :num-inputs="6"
                    :should-auto-focus="true"
                    :is-input-num="true"
                    @on-complete="verifyOTP"
                />
            </div>
            <div v-if="!otpCountDown">
              <span class="text-primary cursor-pointer" @click="sendOTP()"
                >Resend OTP</span
              >
            </div>
            <div v-else>
              <span v-if="otpCountDown > 9"
                >Resend OTP after 00:{{ otpCountDown }} seconds</span
              >
              <span v-else
                >Resend OTP after 00:0{{ otpCountDown }} seconds</span
              >
            </div>
          </div>

          <span>© {{ new Date().getFullYear() }} GetBoarded INC <vs-icon class="mx-2" size="9px" icon="fiber_manual_record"></vs-icon><a href="/privacy-policy" target="_blank">Privacy</a>
              <vs-icon class="mx-2" size="9px" icon="fiber_manual_record"></vs-icon>
              <a href="/terms-of-use" target="_blank">T&C</a></span>
        </div>
      </div>
      <div class="vx-col hidden lg:block lg:w-1/2 login-right">
        <!--<img
          src="@/assets/images/pages/login/login-img.svg"
          alt="login"
          class="mx-auto w-full"
        />-->
      </div>
    </div>
  </div>
</template>


<script>
import constants from "@/constants";
import {
  sendMeOTPService,
  verifyOTPService,
  microsoftLoginService,
} from "@/services/auth.service.js";

export default {
  data() {
    return {
      email: null,
      firstName: '',
      lastName: '',
      userExists: false,
      userCheckComplete: false,
      password: this.email,
      otpSent: false,
      otpCountDown: 59,
      constants,
      productUpdatesCheckbox: true,
    };
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.email !== null;
    },
    isUserLoggedIn() {
      return this.$store.state.auth.isUserLoggedIn;
    },
    microsoftLoginQueryParam() {
      return this.$route.query.microsoftLogin;
    },
    routeUserEmail() {
      return this.$route.query.email;
    },
    addToBoard() {
      return this.$route.query.atb;
    }
  },
  methods: {
    otpTimer() {
      if (this.otpCountDown > 0) {
        setTimeout(() => {
          this.otpCountDown -= 1;
          this.otpTimer();
        }, 1000);
      }
    },
    sendOTP() {
      if (!this.validateForm) {
        return;
      } else if(this.addToBoard) {
        if(!this.userCheckComplete) {
          return;
        } else if(!this.userExists && !this.firstName && !this.lastName) {
          return;
        }
      } 

      this.otpSent = true;
      this.otpCountDown = 59;
      this.otpTimer();

      const breakMail = this.$route.query.breakmail ? this.$route.query.breakmail : false;

      const payload = {
        email: this.email,
        firstName: this.firstName ? this.firstName : '',
        lastName: this.lastName ? this.lastName : '',
        password: Math.random().toString(36).substring(7),
        currentThis: this,
        userSource: "loginPage",
        breakMail: breakMail
      };

      sendMeOTPService(payload);
    },
    verifyOTP(otp) {
      const payload = {
        email: this.email,
        otp,
        currentThis: this,
        userSource: "loginPage",
        atb: this.$route.query.atb ? true : false,
        boardSlug: this.$route.query.boardSlug ? this.$route.query.boardSlug : false
      };

      verifyOTPService(payload);
    },
    microsoftSignIn() {
      window.location.href = `${constants.apiHost}/oauth/microsoft`;
    },
    checkIfUserExists() {
      this.userCheckComplete = false;
      if(this.email && !this.errors.first('email')) {
        this.$store.dispatch('users/fetchUserByEmail', { email: this.email }).then(res => {
          if(res.total === 1) {
            this.userExists = true;
          } else {
            this.userExists = false;
          }
          this.userCheckComplete = true;
        }).catch(err => {
          throw err;
        });
      } else {
        this.userExists = false;
      }
    }
  },
  mounted() {
    if (this.microsoftLoginQueryParam) {
      const data = JSON.parse(this.microsoftLoginQueryParam);
      microsoftLoginService(data);
    } else if (this.isUserLoggedIn) {
      window.location.href = "/user/dashboard";
    }

    // If email is there in query
    this.email = this.routeUserEmail;

    this.$vs.loading.close();
  },
  created() {
    window.location.href = `${constants.apiHost}/oauth`;
  },
};
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }
    .bg-twitter {
      background-color: #00aaff;
    }
    .bg-google {
      background-color: #4285f4;
    }
    .bg-github {
      background-color: #333;
    }
  }
}

#page-login {
    overflow-y: hidden;
}

button {
  border-radius: 6px;
}

.mb-large {
  margin-bottom: 5rem;
}

.vx-card {
  background: #ffffff;
  box-shadow: 0px 8px 40px rgba(0, 0, 0, 0.05);
}

.microsoft-login--btn {
  border: 1px solid #dfe3eb;
}

.microsoft-login--btn .vs-button--text {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: #2d333a;
}

.login-left {
    padding: 2rem 8rem!important;
}

.login-right {
    background-image: url('../../assets/images/pages/login/login-img.svg'), linear-gradient(281.6deg, #F29300 26.43%, #FFC000 123.5%);
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    height: 100vh;
}

@media only screen and (max-width: 1200px) {
    .login-left {
        padding: 0!important;
    }
}
</style>

<style lang="scss">
  .otp-input {
    width: 40px;
    height: 40px;
    padding: 5px;
    margin: 0 10px;
    font-size: 20px;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.3);
    text-align: center;
    &.error {
      border: 1px solid red !important;
    }
  }
  .otp-input::-webkit-inner-spin-button,
  .otp-input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
</style>
